import {
  NS_GET_ANALYSIS_THROUGHPUT_DATA,
  NS_GET_ANALYSIS_THROUGHPUT_DATA_SUCCESS,
  NS_GET_ANALYSIS_THROUGHPUT_DATA_FAIL
} from '../../actions/ns/analystThroughput';

const initialState = {};

export default function analystThroughput(state = initialState, action) {
  switch (action.type) {
    case NS_GET_ANALYSIS_THROUGHPUT_DATA:
      return {
        ...state,
        payload: action.payload
      };
    case NS_GET_ANALYSIS_THROUGHPUT_DATA_SUCCESS:
      return {
        ...state,
        data: action.payload
      };
    case NS_GET_ANALYSIS_THROUGHPUT_DATA_FAIL:
      return {
        ...state
      };
    default:
      return state;
  }
}
